// React component to show alert banner for live tracking status

import React from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ReactComponent as LiveTrackingIcon } from '../../assets/live-tracking-indicator.svg';
import { Equipment } from '../../redux/api/equipment/equipment.model';

export enum LiveEntityType {
  order = 'order',
  trip = 'trip'
}

export enum OrderTripLiveStatus {
  notStarted = 'notStarted',
  inTransit = 'inTransit',
  delivered = 'delivered'
}

export interface TwLiveTrackingAlertProps {
  status: OrderTripLiveStatus;
  equipment?: Equipment;
  timestamp?: string;
  entityType?: LiveEntityType;
}

const TwLiveTrackingAlert: React.FC<TwLiveTrackingAlertProps> = ({
  status,
  timestamp,
  entityType,
  equipment
}): JSX.Element => {
  return (
    <>
      {equipment && equipment?.asset_eld_id && equipment.eld_connection_id && (
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            backgroundColor: status === OrderTripLiveStatus.inTransit ? '#FFF' : '#111827',
            borderTop: '1px solid #D1D5DB',
            padding: '0.5rem 1rem'
          }}
        >
          <LiveTrackingIcon
            stroke={status === OrderTripLiveStatus.inTransit ? '#3A4DE9' : '#9CA3AF'}
          />
          <Typography
            variant="body2"
            fontWeight="400"
            fontSize="14px"
            color={status === OrderTripLiveStatus.inTransit ? '1F2937' : '#FFFFFF'}
          >
            {status === OrderTripLiveStatus.inTransit
              ? `Tracking updated ${timestamp ?? ''}`
              : `Tracking unavailable:  ${entityType === LiveEntityType.order ? 'Order' : 'Trip'} ${
                  status === OrderTripLiveStatus.notStarted ? 'not started' : 'delivered'
                }`}
          </Typography>
        </Stack>
      )}
    </>
  );
};

export default TwLiveTrackingAlert;
